import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import EmailFoldersAPI from 'dashboard/api/emailFolders';

// Estado compartilhado: o botão do menu e o da lista mostram o mesmo andamento.
const syncingKeys = ref(new Set());

const keyFor = inboxId => (inboxId ? String(inboxId) : 'all');

// Antecipa a leitura IMAP (Caixa de Entrada) de uma caixa de e-mail ou de todas.
// Só enfileira: os e-mails novos chegam à lista em tempo real quando o worker termina.
export function useEmailSync() {
  const { t } = useI18n();

  const isSyncing = inboxId => syncingKeys.value.has(keyFor(inboxId));

  const setSyncing = (inboxId, value) => {
    const next = new Set(syncingKeys.value);
    if (value) next.add(keyFor(inboxId));
    else next.delete(keyFor(inboxId));
    syncingKeys.value = next;
  };

  const syncEmails = async inboxId => {
    if (isSyncing(inboxId)) return;

    setSyncing(inboxId, true);
    try {
      const { data } = await EmailFoldersAPI.sync(inboxId);
      const queued = data?.queued?.length || 0;
      const throttled = data?.throttled?.length || 0;

      if (queued) useAlert(t('EMAIL_SYNC.QUEUED'));
      else if (throttled) useAlert(t('EMAIL_SYNC.THROTTLED'));
      else useAlert(t('EMAIL_SYNC.NOTHING_TO_SYNC'));
    } catch (error) {
      useAlert(error?.response?.data?.error || t('EMAIL_SYNC.ERROR'));
    } finally {
      setSyncing(inboxId, false);
    }
  };

  return { isSyncing, syncEmails };
}
